<p-confirmDialog [key]="'CRUDBasicDetailConfirmDialog_'+CRUDItemBezeichnungPluralCapitalized" [appendTo]="confirmDialogAppendTo()" [acceptLabel]="translate.instant('Ja',true)" [rejectLabel]="translate.instant('Nein',true)"></p-confirmDialog>
<!-- [style]="{'z-index': '9999'}" -->
<!-- <p-blockUI [blocked]="blockedDocument">
  <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="position:absolute;top:25%;left:50%"></i>
</p-blockUI> -->
<ng-container *ngTemplateOutlet="CRUDTemplatePluginTop"></ng-container>
<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-g-nopad">
    <div class="ui-g-12 ui-lg-12" style="padding-top:0">
      <form [formGroup]="CRUDForm" #form (ngSubmit)="validateAndSaveCRUDItem(true)" novalidate>
        <div #divCardToolbar class="card">
          <!-- [ngClass]="CRUDTemplatePluginTop == null ? 'card-toolbar' : null" [class.card-toolbar-static-inactive]="(app.isOverlay() || app.isHorizontal() || app.staticMenuDesktopInactive === true || !app.isDesktop()) && !app.isSlim()"
          [class.card-toolbar-horizontal-active]="!app.isOverlay() && app.isHorizontal() && app.isDesktop()"
          [class.card-toolbar-slim-active]="app.isSlim()"-->
          <!-- class="card card-toolbar" US 14470 Toolbar nur fixiert, wenn kein CRUDTemplatePluginTop drüber -->

          <!--MODI ggü IMKE: Die Buttonleiste ist in einem Grid, weil in der Mitte: pageTitle -->
          <div class="titlebar-button-grid">
            <div>
              <!--<button style="width: auto;" pButton type="submit" icon="ui-icon-save" [label]="translate.instant('Speichern',true)"></button>-->
              <button style="width: auto;" pButton type="submit" [icon]="CRUDButtonSaveIcon" [label]="translate.instant(CRUDButtonSaveLabel,true)"></button>
            </div>
            <div style="text-align: center;">
              <span style="line-height: 35px; font-size: medium; font-weight: 500;">{{pageTitle}}</span>
            </div>
            <div>
              <span class="floatRight">
              <!--<button style="width: auto;" pButton type="button" icon="ui-icon-help" [label]="translate.instant('Hilfe',true)" (click)="showHelp()"></button>-->
              <button style="width: auto; margin-left: 5px;" pButton type="button" icon="ui-icon-close" [label]="translate.instant('Abbrechen',true)"
                (click)="cancelCRUDEdit()"></button><!-- [routerLink]="['/'+CRUDItemRoutePlural]"-->
              </span>
            </div>
          </div>

        </div>

        <div [ngClass]="CRUDTemplatePluginTop == null ? 'card-container' : null"><!-- class="card-container" US 14470 Toolbar nur fixiert, wenn kein CRUDTemplatePluginTop drüber -->
          <div class="card">
            <div class="ui-g form-group" id="parentDiv">

              <!--CHILD_CONTENT-->
              <!--<ng-container *ngIf="true==true; then CRUDChildTemplate">das hier dazw. wird niemals angezeigt!</ng-container>-->
              <ng-container *ngTemplateOutlet="CRUDChildTemplate"></ng-container>

              <!--<div class="ui-g-12 ui-md-12">
                  <div class="ui-g-12 ui-md-6">
                    <button pButton type="button" icon="ui-icon-delete" class="ui-button-danger" [label]="translate.instant(this.CRUDItemKurzform+ ' löschen',true)"
                      (click)="deleteCRUDItem()"></button>
                  </div>
              </div>-->

            </div>
          </div>
          <div class="card" style="display: none;"><!--MODI: kein Footer-->
            <!--<app-footer-info *ngIf="CRUDHideModified == false" [data]="CRUDItem" [deleteButtonLabel]="CRUDDisableLoeschen ? null : translate.instant(this.CRUDItemKurzform+ ' löschen',true)" (delete)="deleteCRUDItem()"></app-footer-info>-->

            <div *ngIf="CRUDHideModified == true" class="ui-g">
              <div class="ui-g-12 ui-md-12">
                <div class="ui-g-12 ui-md-6 ui-lg-3">
                  <button pButton type="button" icon="ui-icon-delete" class="ui-button-danger" [label]="translate.instant('Löschen',true)"
                    (click)="deleteCRUDItem()"></button>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <!--</fieldset>-->
      </form>
    </div>
  </div>
</div>
<button *ngIf="debugMode == true" pButton (click)="debug(form)" icon="fa-bug" title="debug form"></button>

<ng-template #CRUDChildTemplate>
  <div class="detail-grid">
    <!--
            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="benutzer">
                <label>{{'Benutzer'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.benutzer}}
              </div>
            </div>
-->            

            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="bezeichnung" [attr.disabled]="benutzer == null || benutzer.istAdmin != true ? 'disabled' : null">
                <label>{{'Name'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></i></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.bezeichnung}}
              </div>
            </div>


            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="strasse" [attr.disabled]="benutzer == null || benutzer.istAdmin != true ? 'disabled' : null">
                <label>{{'Strasse'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></i></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.strasse}}
              </div>
            </div>

            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="plz" [attr.disabled]="benutzer == null || benutzer.istAdmin != true ? 'disabled' : null">
                <label>{{'Postleitzahl'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></i></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.plz}}
              </div>
            </div>

            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="ort" [attr.disabled]="benutzer == null || benutzer.istAdmin != true ? 'disabled' : null">
                <label>{{'Ort'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></i></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.ort}}
              </div>
            </div>

            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="ortzusatz" [attr.disabled]="benutzer == null || benutzer.istAdmin != true ? 'disabled' : null">
                <label>{{'Ortszusatz'|translate:true}}</label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.ortzusatz}}
              </div>
            </div>


            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="email" [attr.disabled]="benutzer == null || benutzer.istAdmin != true ? 'disabled' : null">
                <label>{{'E-Mail'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></i></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.email}}
              </div>
            </div>

<!--            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="kopfdaten">
                <label>{{'Kopfdaten'|translate:true}} <i class="fa-regular fa-circle-exclamation fa-xs"></label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.kopfdaten}}
              </div>
            </div>
-->
            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm" [style.display]="benutzer == null || benutzer.istAdmin != true || benutzer.dienstleister == null || (benutzer.dienstleister.zuordnung != null && benutzer.dienstleister.zuordnung != '') ? 'none' : 'unset'">
              <span class="p-float-label">
                <input style="width:90%" type="text" pInputText formControlName="zuordnung">
                <label>{{'Zuordnung'|translate:true}}</label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6" [style.display]="benutzer == null || benutzer.istAdmin != true || benutzer.dienstleister == null || (benutzer.dienstleister.zuordnung != null && benutzer.dienstleister.zuordnung != '') ? 'none' : 'unset'">
              <div class="errorMessage">
                {{displayMessage.zuordnung}}
              </div>
            </div>

            <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
              <span class="p-float-label">
                <crud-basic-checkbox formControlName="spediteur" [nullable]="false" [label]="translate.instant('Spediteur',true)"></crud-basic-checkbox>
              </span>
            </div>
            <div class="ui-g-12 ui-md-6">
              <div class="errorMessage">
                {{displayMessage.spediteur}}
              </div>
            </div>


  </div>

  <app-benutzer-list #benutzerList *ngIf="CRUDItem != null"
  [parentCrudItem]="CRUDItem" [parentComponent]="this"
  [crudItems]="CRUDItem.benutzer"
  (crudItemsValueChange)="onCrudItemsValueChangeBenutzer($event)" [style.width]="'100%'"></app-benutzer-list>

</ng-template>
    
